import sprintf from 'sprintf';

function twelveHourTimeFilter() {
    'ngInject';

    return function (time, options) {

        if (!angular.isNumber(time)) {
            return;
        }

        const omit_mins_on_hour = (options && options.omit_mins_on_hour) || false;
        const separator = options && options.separator ? options.separator : ':';

        const t = time;
        let h = Math.floor(t / 60);
        const m = t % 60;
        let suffix = 'am';
        if (h >= 12) {
            suffix = 'pm';
        }
        if (h > 12) {
            h -= 12;
        }
        if ((m === 0) && omit_mins_on_hour) {
            time = `${h}`;
        } else {
            time = `${h}${separator}` + sprintf('%02d', m);
        }
        time += suffix;
        return time;
    };
}

angular
    .module('BB')
    .filter('twelve_hour_time', twelveHourTimeFilter);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_filters/twelve_hour_time.filter.js